import React, { useEffect, useMemo, useRef } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, FormRef } from "devextreme-react/form";
import IContratDefinition from "../../models/IContratDefinition";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import IGestionContratDefinition from '../../models/IGestionContratDefinition';

export default function GestionContrats() {
  const contratDataSourceOption: IFormBaseDataSourceOptions<IGestionContratDefinition> = useMemo(() => ({
    path: "contratDefinition",
    primaryKey: "idContratDefinition",
    customReadByIdPath: "contratDefinition/{key}/gestion",
    customSauvegarderPath: "contratDefinition/save"
  }), []);
  const contratFormDataSource = useCustomDataSource<IContratDefinition, IGestionContratDefinition>(contratDataSourceOption);
  const { setMainForm, selectedDataRow: selectedContrat, onFieldDataChanged, mode, setMode, isFieldModifier, setIsFieldModifier } = contratFormDataSource;
  const formRef = useRef<FormRef>(null);

  const descriptionEditorOptions = useMemo(() => {
    return { width: "100%" };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture)
      formRef.current?.instance().getEditor("description")?.focus();
  }, [mode !== Mode.Lecture])

  return (
    <FormListBase data={contratFormDataSource}>
      <FormListBaseGrid dataSource={contratFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
        }}
      >
        <Column key={"grid-col-nom"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedContrat?.description || ''} `} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ disabled: !isFieldModifier }} />
      <FormListBaseTab>
        <TabItem title="Informations">
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedContrat || {} as IContratDefinition} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                <SimpleItem key={"description"} dataField={"description"} editorOptions={descriptionEditorOptions}>
                </SimpleItem>
                <GroupItem caption={"Cumulatifs"}>
                  <GroupItem>
                    <DataGrid showBorders={true} allowColumnResizing={true}>
                      <Column caption={"Module"} />
                      <Column caption={"Montant"} />
                    </DataGrid>
                  </GroupItem>
                </GroupItem>
              </Form>
            </div>
          </div>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedContrat || {} as IContratDefinition} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}